export default {
  ALL_FLIGHTS_REQUEST: 'ALL_FLIGHTS_REQUEST',
  ALL_FLIGHTS_SUCCESS: 'ALL_FLIGHTS_SUCCESS',
  ALL_FLIGHTS_FAILURE: 'ALL_FLIGHTS_FAILURE',
};



// WEBPACK FOOTER //
// ./src/redux/constants/AllFlightsConstants.js